import { get, includes } from 'lodash';
import React from 'react';
import { Field } from 'src/components/RcForm';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  marginToBottom,
  marginToHCenter,
  marginToLeft,
  marginToRight,
  marginToTop,
  marginToVCenter,
  positionOption as pK,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EnumPosition } from 'src/types/common/common';
import { EPositionOption } from 'src/types/common/module';

const Sliders = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const generator = (list) => {
    return (
      <React.Fragment>
        {list.map((i) => {
          const { title, key, position } = i;
          return (
            <Field name={key} key={key}>
              {(props, meta) => {
                return (
                  <Slider
                    title={title}
                    position={position}
                    value={props.value}
                    onChange={props.onChange}
                  />
                );
              }}
            </Field>
          );
        })}
      </React.Fragment>
    );
  };
  return (
    <Field
      shouldUpdate={(p, c) => {
        return get(p, pK) !== get(c, pK);
      }}>
      {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
        const positionOption = getFieldValue(pK);
        const len = (positionOption || []).length;
        if (len === 1) {
          if (includes(positionOption, EPositionOption.Center)) {
            return (
              <React.Fragment>
                {generator([
                  {
                    title: getI18n(
                      'salesChannelContent.index.margintoHorizontalCentreLine',
                    ),
                    key: marginToHCenter,
                    position: EnumPosition.center,
                  },
                  {
                    title: getI18n(
                      'salesChannelContent.index.margintoVerticalCentreLine',
                    ),
                    key: marginToVCenter,
                    position: EnumPosition.center,
                  },
                ])}
              </React.Fragment>
            );
          }
        }
        if (len === 2) {
          if (includes(positionOption, EPositionOption.Center)) {
            if (includes(positionOption, EPositionOption.Bottom)) {
              return (
                <React.Fragment>
                  {generator([
                    {
                      title: getI18n(
                        'salesChannelContent.index.margintoHorizontalCentreLine',
                      ),
                      key: marginToHCenter,
                      position: EnumPosition.center,
                    },
                    {
                      title: getI18n('general.margintoBottomEdge'),
                      key: marginToBottom,
                      position: EnumPosition.bottom,
                    },
                  ])}
                </React.Fragment>
              );
            }
            if (includes(positionOption, EPositionOption.Top)) {
              return (
                <React.Fragment>
                  {generator([
                    {
                      title: getI18n(
                        'salesChannelContent.index.margintoHorizontalCentreLine',
                      ),
                      key: marginToHCenter,
                      position: EnumPosition.center,
                    },
                    {
                      title: getI18n('general.margintoTopEdge'),
                      key: marginToTop,
                      position: EnumPosition.top,
                    },
                  ])}
                </React.Fragment>
              );
            }
            if (includes(positionOption, EPositionOption.Left)) {
              return (
                <React.Fragment>
                  {generator([
                    {
                      title: getI18n('general.margintoLeftEdge'),
                      key: marginToLeft,
                      position: EnumPosition.left,
                    },
                    {
                      title: getI18n(
                        'salesChannelContent.index.margintoVerticalCentreLine',
                      ),
                      key: marginToVCenter,
                      position: EnumPosition.center,
                    },
                  ])}
                </React.Fragment>
              );
            }
            if (includes(positionOption, EPositionOption.Right)) {
              return (
                <React.Fragment>
                  {generator([
                    {
                      title: getI18n('general.margintoRightEdge'),
                      key: marginToRight,
                      position: EnumPosition.right,
                    },
                    {
                      title: getI18n(
                        'salesChannelContent.index.margintoVerticalCentreLine',
                      ),
                      key: marginToVCenter,
                      position: EnumPosition.center,
                    },
                  ])}
                </React.Fragment>
              );
            }
          } else {
            if (includes(positionOption, EPositionOption.Bottom)) {
              if (includes(positionOption, EPositionOption.Left)) {
                return (
                  <React.Fragment>
                    {generator([
                      {
                        title: getI18n('general.margintoLeftEdge'),
                        key: marginToLeft,
                        position: EnumPosition.left,
                      },
                      {
                        title: getI18n('general.margintoBottomEdge'),
                        key: marginToBottom,
                        position: EnumPosition.bottom,
                      },
                    ])}
                  </React.Fragment>
                );
              }
              if (includes(positionOption, EPositionOption.Right)) {
                return (
                  <React.Fragment>
                    {generator([
                      {
                        title: getI18n('general.margintoRightEdge'),
                        key: marginToRight,
                        position: EnumPosition.right,
                      },
                      {
                        title: getI18n('general.margintoBottomEdge'),
                        key: marginToBottom,
                        position: EnumPosition.bottom,
                      },
                    ])}
                  </React.Fragment>
                );
              }
            }
            if (includes(positionOption, EPositionOption.Top)) {
              if (includes(positionOption, EPositionOption.Left)) {
                return (
                  <React.Fragment>
                    {generator([
                      {
                        title: getI18n('general.margintoLeftEdge'),
                        key: marginToLeft,
                        position: EnumPosition.left,
                      },
                      {
                        title: getI18n('general.margintoTopEdge'),
                        key: marginToTop,
                        position: EnumPosition.top,
                      },
                    ])}
                  </React.Fragment>
                );
              }
              if (includes(positionOption, EPositionOption.Right)) {
                return (
                  <React.Fragment>
                    {generator([
                      {
                        title: getI18n('general.margintoRightEdge'),
                        key: marginToRight,
                        position: EnumPosition.right,
                      },
                      {
                        title: getI18n('general.margintoTopEdge'),
                        key: marginToTop,
                        position: EnumPosition.top,
                      },
                    ])}
                  </React.Fragment>
                );
              }
            }
          }
        }
        return null;
      }}
    </Field>
  );
};
export { Sliders };
